"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @deckee/app-main
 * App main integration endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jason@deckee.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationItemToJSON = exports.NotificationItemFromJSONTyped = exports.NotificationItemFromJSON = exports.instanceOfNotificationItem = exports.NotificationItemTypeEnum = void 0;
/**
 * @export
 */
exports.NotificationItemTypeEnum = {
    ActivateSignal: 'ActivateSignal',
    UserFollowing: 'UserFollowing',
    SharedMarker: 'SharedMarker',
    SignalShared: 'SignalShared',
    IncidentReported: 'IncidentReported',
    FloatPlanNotification: 'FloatPlanNotification',
    Generic: 'Generic',
    OfflineIncidentReportAvailable: 'OfflineIncidentReportAvailable',
    WatercraftNotification: 'WatercraftNotification',
    ExternalLink: 'ExternalLink'
};
/**
 * Check if a given object implements the NotificationItem interface.
 */
function instanceOfNotificationItem(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "heading" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "read" in value;
    isInstance = isInstance && "iconImage" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "externalId" in value;
    isInstance = isInstance && "externalModel" in value;
    isInstance = isInstance && "updatedAt" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "data" in value;
    return isInstance;
}
exports.instanceOfNotificationItem = instanceOfNotificationItem;
function NotificationItemFromJSON(json) {
    return NotificationItemFromJSONTyped(json, false);
}
exports.NotificationItemFromJSON = NotificationItemFromJSON;
function NotificationItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'heading': json['heading'],
        'description': json['description'],
        'read': json['read'],
        'iconImage': json['iconImage'],
        'type': json['type'],
        'externalId': json['externalId'],
        'externalModel': json['externalModel'],
        'updatedAt': (new Date(json['updatedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'data': json['data'],
    };
}
exports.NotificationItemFromJSONTyped = NotificationItemFromJSONTyped;
function NotificationItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'heading': value.heading,
        'description': value.description,
        'read': value.read,
        'iconImage': value.iconImage,
        'type': value.type,
        'externalId': value.externalId,
        'externalModel': value.externalModel,
        'updatedAt': (value.updatedAt.toISOString()),
        'createdAt': (value.createdAt.toISOString()),
        'data': value.data,
    };
}
exports.NotificationItemToJSON = NotificationItemToJSON;
